module.exports = __webpack_public_path__ + "img/coach.eff43edc.svg";